<template>
  <div class="account account__electron">
    <el-form class="account-form" label-width="78px" size="medium">
      <div class="item-wrap">
        <el-form-item label="用户ID">
          <p class="form-content" v-if="user && user.user_id">
            {{ user.user_id }}
          </p>
        </el-form-item>
        <el-form-item label="密码">
          <template v-if="isHasPassword">
            <p class="form-content">已设置</p>
            <el-button class="default-btn" @click="openPassDialog"
              >修改密码</el-button
            >
          </template>
          <template v-else>
            <p class="form-content">未设置</p>
            <el-button class="bind-btn" @click="openSetPassDialog"
              >设置密码</el-button
            >
          </template>
        </el-form-item>
      </div>
      <div class="item-wrap">
        <el-form-item label="手机号">
          <p class="form-content" v-if="user && user.mobile">
            {{ user.mobile }}
          </p>
          <el-button class="default-btn" @click="openMobileDialog"
            >换绑手机号</el-button
          >
        </el-form-item>
        <el-form-item label="微信">
          <div class="form-content">
            <img
              v-if="isBindWechat"
              src="../../../assets/images/user-info/wechat.png"
              alt=""
            />
            <img
              v-else
              src="../../../assets/images/user-info/un-active-wx.png"
              alt=""
            />
          </div>
          <el-popover
            placement="bottom-start"
            v-model="bindPopoverVisible"
            popper-class="bind-wechat-popover"
            @show="getQrCode"
            @hide="onLeaveBindPopover"
          >
            <el-button
              slot="reference"
              :class="{
                'bind-btn': !isBindWechat,
                'default-btn': isBindWechat,
              }"
              >{{ isBindWechat ? "解绑" : "去绑定" }}</el-button
            >
            <div class="wechat-box">
              <p>使用微信扫一扫登录</p>
              <div class="qr-code-box">
                <img :src="qrParams.qr_code" alt="" />
                <img class="logo-img" :src="faviconUrl" alt="" />
                <div
                  class="qr-scan-mask-cover"
                  @click="refreshQRCode(true)"
                  v-if="isLoadingQRCode || qrCodeExpired"
                >
                  <span
                    class="newLogin_scan-refresh"
                    :class="{ 'loading-refresh': isLoadingQRCode }"
                  >
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-icon="RefreshOutlined"
                    >
                      <path
                        d="M17.745 8a7 7 0 1 0 .965 6h2.067A9 9 0 1 1 19 6.343V4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.745Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  {{ isLoadingQRCode ? "加载中" : "刷新二维码" }}
                  <div class="refresh-mask"></div>
                </div>
              </div>
              <p>关注魔果云课服务号</p>
            </div>
          </el-popover>
        </el-form-item>
      </div>
    </el-form>
    <div class="device-area" v-if="isElectron">
      <div class="login-device">
        <div class="title">
          <span>登录设备</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="为了保障您的账号安全，同时登录设备数量不可超过3个，且在数量超出后会将您最早登录的账号下线。"
            placement="top-start"
          >
            <img src="../../../assets/images/user-info/tips.png" alt="" />
          </el-tooltip>
        </div>
        <div class="tips">同时登录设备数量不可超过3个</div>
        <div class="device-list">
          <div
            class="device-item"
            v-for="(item, index) in loginDeviceList"
            :key="index"
          >
            <img :src="getIcon(item)" alt="" />
            <div class="device-info">
              <div class="device-content">
                <div class="device-name">{{ item.device_name || "-" }}</div>
                <div class="login-time">
                  最近登录：{{ item.last_login_time | formatTimestamp }}
                </div>
              </div>
              <div class="tag">
                <div v-if="isSelf(item.device_unique_id)">本机</div>
                <div
                  class="remove-btn"
                  v-else
                  @click="handleRemoveDevice(item)"
                >
                  移除
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="device-manage">
        <div class="title">
          <span>设备管理</span>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              老师开启仅限绑定设备观看后，您可以通过绑定至多{{
                orgDeviceConfig.device_count
              }}台设备（{{ orgDeviceConfig.phone === 1 ? "手机/pad" : ""
              }}{{
                orgDeviceConfig.computer === 1
                  ? orgDeviceConfig.phone === 1
                    ? "/电脑"
                    : "电脑"
                  : ""
              }}）观看课程，其他设备不能观看
            </div>
            <img src="../../../assets/images/user-info/tips.png" alt="" />
          </el-tooltip>
        </div>
        <div class="input-box">
          <!-- :remote-method="getOrgList" -->
          <span class="label">所属老师</span>
          <el-select
            v-model="orgId"
            filterable
            reserve-keyword
            placeholder="请输入关键词"
            remote
            size="small"
            @change="changeOrg"
          >
            <el-option
              v-for="item in orgList"
              :key="item.org_id"
              :label="item.org_name"
              :value="item.org_id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="device-list">
          <div
            class="device-item"
            v-for="(item, index) in deviceList"
            :key="index"
          >
            <img :src="getIcon(item)" alt="" />
            <div class="device-info">
              <div class="device-content">
                <div class="device-name">{{ item.device_name }}</div>
                <div class="login-time">
                  最近登录：{{ item.last_login_time | formatTimestamp }}
                </div>
              </div>
              <div class="tag">
                <div class="bind-status">
                  <span v-if="isSelf(item.device_unique_id)">本机·</span>
                  <span>已绑定</span>
                </div>
                <div class="remove-btn" @click="handleUnbindDevice(item)">
                  解绑
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <UpdatePassword ref="updatePassword" @success="handleSuccess" />
    <UpdateMobile ref="updateMobile" @success="handleSuccess" />
    <SetPassword ref="setPassword" @success="handleSetPassSuccess" />
    <remove-dialog :show.sync="removeDialogVisible" title="移除设备">
      <div class="remove-conent">
        <p class="tips">确定要移除此设备吗？</p>
        <div class="btn-box">
          <el-button
            type="default"
            size="small"
            @click="removeDialogVisible = false"
          >
            取消
          </el-button>
          <el-button type="primary" size="small" @click="confirmRemove">
            确认移除
          </el-button>
        </div>
      </div>
    </remove-dialog>
  </div>
</template>

<script>
import SetPassword from "./SetPassword";
import UpdateMobile from "./UpdateMobile.vue";
import UpdatePassword from "./UpdatePassword";
import MgDialog from "@saas/components/src/components/mg-dialog/Index.vue";
import { getCdnUrl } from "@saas/components/src";

import { mapGetters, mapActions } from "vuex";
import {
  getDeviceList,
  removeDevice,
  getOrgDeviceConfig,
  getStudentOrgList,
} from "@saas/service-api/src/device/index";
import {
  getBindWechatCode,
  bindWechat,
} from "@saas/service-api/src/user-info/index";
// 临时兼容 file:// -> moguo:// 迁移期“本机”标识。
// legacy id 仅用于展示/排序兜底，不参与登录 device_unique_id 上报。
const LEGACY_FILE_PROTOCOL_DEVICE_ID_KEY = "__electronFileProtocolDeviceId";
export default {
  data: function () {
    return {
      timer: null,
      isElectron: window.isElectron,
      pcIcon: require("../../../assets/images/user-info/pc.png"),
      padIcon: require("../../../assets/images/user-info/pad.png"),
      phoneIcon: require("../../../assets/images/user-info/phone.png"),
      orgId: "",
      orgList: [],
      removeDialogVisible: false,
      selectLoginDevice: {},
      loginDeviceList: [],
      deviceList: [],
      orgDeviceConfig: {},
      qrParams: {},
      bindTimer: null,
      bindPopoverVisible: false,
      isLoadingQRCode: false,
      qrCodeExpired: false,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      faviconUrl: getCdnUrl("/cdn/static/images/favicon.ico"),
    };
  },
  mounted() {
    this.getLoginDevice();
    this.getOrgList();
  },
  methods: {
    ...mapActions(["getProfile"]),
    ...mapActions("user", ["getInfo"]),
    handleSetPassSuccess() {
      this.$message.success("设置成功");
      // 更新用户信息
      if (window.isElectron) {
        this.getInfo();
      } else {
        this.getProfile();
      }
    },
    //  获取机构列表
    getOrgList() {
      getStudentOrgList().then((res) => {
        if (res.code === 1) {
          this.orgList = res.data || [];
        }
      });
    },
    // 获取机构绑定设备配置
    getOrgDeviceConfig() {
      getOrgDeviceConfig({
        org_id: this.orgId,
      }).then((res) => {
        if (res.code === 1) {
          this.orgDeviceConfig = res.data;
        }
      });
    },
    // 切换机构
    changeOrg() {
      this.getOrgDeviceConfig();
      this.getBindDeviceList();
    },
    //  获取机构绑定设备
    getBindDeviceList() {
      return getDeviceList({
        org_id: this.orgId,
      }).then((res) => {
        if (res.code === 1) {
          this.deviceList = (res.data || []).sort((item) =>
            this.isSelf(item.device_unique_id) ? -1 : 1
          );
        }
      });
    },
    //  获取登录过的设备
    getLoginDevice() {
      getDeviceList().then((res) => {
        if (res.code === 1) {
          this.loginDeviceList = (res.data || []).sort((item) =>
            this.isSelf(item.device_unique_id) ? -1 : 1
          );
        }
      });
    },
    // 移除设备
    handleRemoveDevice(item) {
      this.removeDialogVisible = true;
      this.selectLoginDevice = item;
    },
    // 确认移除
    confirmRemove() {
      removeDevice({
        id: this.selectLoginDevice.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success("移除成功");
          this.removeDialogVisible = false;
          this.getLoginDevice();
        }
      });
      //   this.$electron.ipcRenderer.send("removeDevice");
    },
    // 点击解绑
    handleUnbindDevice() {
      this.$message.warning("暂不支持学员解绑设备，请联系老师");
    },
    getIcon(item) {
      if ([1, 2].includes(item.device_type)) {
        return this.pcIcon;
      } else if (item.device_type === 5) {
        return this.padIcon;
      } else if ([3, 4].includes(item.device_type)) {
        return this.phoneIcon;
      } else {
        return this.phoneIcon;
      }
    },
    isSelf(id) {
      const deviceIds = [
        localStorage.getItem("deviceId"),
        localStorage.getItem(LEGACY_FILE_PROTOCOL_DEVICE_ID_KEY),
      ].filter(Boolean);
      return deviceIds.includes(id);
    },
    openSetPassDialog() {
      this.$refs["setPassword"].showDialog();
    },
    openPassDialog() {
      this.$refs["updatePassword"].showDialog();
    },
    openMobileDialog() {
      this.$refs["updateMobile"].showDialog();
    },
    handleSuccess() {
      let time = 5;
      this.$confirm(
        `修改成功，<span id='quit-timed' style='color: #2AB18A'>${time}</span>s秒后会退出登录~`,
        "",
        {
          center: true,
          customClass: "auto-message",
          showCancelButton: false,
          showConfirmButton: false,
          dangerouslyUseHTMLString: true,
        }
      );
      this.timer = setInterval(() => {
        time--;
        document.getElementById("quit-timed").innerHTML = time; //实现动态渲染
        if (time == 0) {
          clearInterval(this.timer); //如果到0清除倒计时
          this.$msgbox.close(false); //关闭弹窗
          this.$store.dispatch("clearProfile");
        }
      }, 1000);
    },
    getQrCode() {
      this.isLoadingQRCode = true;
      this.qrCodeExpired = false;
      getBindWechatCode()
        .then((res) => {
          if (res.code === 1) {
            this.isLoadingQRCode = false;
            this.qrParams = res.data;
            clearInterval(this.bindTimer);
            this.bindTimer = setInterval(() => {
              bindWechat({
                action: this.isBindWechat ? 2 : 1,
                scene_str: this.qrParams.scene_str,
              })
                .then((res) => {
                  if (res.code === 1) {
                    this.bindPopoverVisible = false;
                    clearInterval(this.bindTimer);
                    if (window.isElectron) {
                      this.$store.dispatch("user/getInfo");
                    } else {
                      this.$store.dispatch("getProfile");
                    }
                  } else if (res.code === 10038) {
                    //  等待扫码中
                  } else {
                    clearInterval(this.bindTimer);
                    this.qrCodeExpired = true;
                    this.$message.error(res.message);
                  }
                })
                .catch(() => {
                  clearInterval(this.bindTimer);
                  this.isLoadingQRCode = false;
                  this.qrCodeExpired = true;
                });
            }, 1000);
          } else {
            this.isLoadingQRCode = false;
            this.qrCodeExpired = true;
          }
        })
        .catch(() => {
          this.isLoadingQRCode = false;
          this.qrCodeExpired = true;
        });
    },
    refreshQRCode() {
      this.getQrCode();
    },
    onLeaveBindPopover() {
      clearInterval(this.bindTimer);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.bindTimer);
  },
  computed: {
    ...mapGetters(["user"]),
    isBindWechat() {
      return this.user.bind_wx_id;
    },
    isHasPassword() {
      return this.user.has_password;
    },
  },
  watch: {
    user: {
      handler() {
        this.orgId = this.user.org_id;
        this.getOrgDeviceConfig();
        this.getBindDeviceList();
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    UpdatePassword,
    UpdateMobile,
    RemoveDialog: MgDialog,
    SetPassword,
  },
};
</script>

<style lang="scss" scoped>
.account {
  .account-form {
    width: 1200px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .item-wrap {
      background: var(--card-bg, #ffffff);
      border-radius: 16px;
      width: 590px;
      padding: 0 22px 0 14px;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0;
      border-bottom: 1px solid var(--border-color, #efefef);
      padding: 10px 0 10px 0;
      // 奇数
      // &:nth-child(odd) {
      //   border: none;
      // }
      // 偶数
      &:nth-child(even) {
        border: none;
      }
      // 倒数第一个
      // &:last-child {
      //   border: none;
      // }
      // // 倒数第二个
      // &:nth-last-child(2) {
      //   border: none;
      // }
      .el-form-item__label {
        width: 78px;
        padding-left: 6px;
        line-height: 30px;
        text-align: left;
        color: var(--text-secondary, #515350);
      }
      .el-form-item__content {
        display: flex;
        align-items: center;
        height: 30px;
        overflow: hidden;
        line-height: 30px;
        justify-content: flex-start;
      }
      .default-btn,
      .bind-btn {
        background: unset;
        width: 80px;
        height: 30px;
        border-radius: 8px;
        border: 1px solid var(--border-color, #efefef);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-weight: 400;
          font-size: 14px;
          color: var(--text-primary, #0d1400);
        }
      }
      .bind-btn {
        border: 1px solid #00c89d;
        span {
          color: #00c89d;
        }
      }
    }
    .form-content {
      // width: 116px;
      flex: 1;
      color: var(--text-primary, #0d1400);
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .account-form.el-form {
    // padding: 4px 14px 0 14px;
    // border-radius: 0 0 8px 8px;
  }
}
.account__electron {
  .account-form.el-form {
    border-radius: 16px;
  }
  .device-area {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .login-device {
    margin-right: 20px;
  }
  .login-device,
  .device-manage {
    flex: 1;
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 14px 20px;
    .title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 500;
      font-size: 14px;
      color: var(--text-primary, #0d1400);
      line-height: 20px;
      img {
        margin-left: 6px;
        width: 12px;
        height: 12px;
      }
    }
    .tips {
      margin-top: 2px;
      font-weight: 400;
      font-size: 12px;
      color: var(--text-secondary, #747573);
      line-height: 17px;
    }
    .device-list {
      margin-top: 14px;
      .device-item {
        display: flex;
        margin-top: 14px;

        & > img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
          margin-top: 2px;
        }
        .device-info {
          flex: 1;
          justify-content: space-between;
          display: flex;
          height: 56px;
          border-bottom: 1px solid var(--border-color, #efefef);
          .device-content {
            .device-name {
              height: 20px;
              font-weight: 400;
              font-size: 14px;
              color: var(--text-primary, #0d1400);
              line-height: 20px;
            }
            .login-time {
              margin-top: 4px;
              font-weight: 400;
              font-size: 12px;
              color: var(--text-secondary, #515350);
              line-height: 17px;
            }
          }
          .tag {
            div {
              width: 52px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 8px;
              font-weight: 400;
              font-size: 14px;
              color: var(--text-primary, #0d1400);
            }
            .remove-btn {
              cursor: pointer;
              line-height: 28px;
              border: 1px solid var(--border-color, #efefef);
            }
          }
        }
        &:last-child {
          .device-info {
            border-bottom: none;
          }
        }
      }
    }
  }
  .login-device {
    .remove-btn {
      margin-top: 5px !important;
    }
  }

  .device-manage {
    flex: 1;
    background: var(--card-bg, #fff);
    border-radius: 12px;
    .input-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 14px;
      .label {
        font-size: 14px;
        color: var(--text-secondary, #515350);
        line-height: 28px;
        margin-right: 16px;
      }
      .el-select :v-deep {
        height: 32px;
        input {
          height: 32px;
          border-radius: 8px;
        }
      }
    }
    .device-list {
      .device-item {
        .device-info {
          .tag {
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            .bind-status {
              width: 100px;
              height: 20px;
              font-weight: 500;
              font-size: 14px;
              color: var(--text-primary, #0d1400);
              line-height: 20px;
              text-align: right;
            }
            .remove-btn {
              margin-top: 4px;
              width: 52px;
              height: 24px !important;
              line-height: 24px !important;
              text-align: center;
              border-radius: 8px;
              cursor: pointer;
              line-height: 22px !important;
              border: 1px solid var(--border-color, #efefef);
            }
          }
        }
      }
    }
  }
}
.remove-conent {
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: var(--text-secondary, #515350);
    line-height: 22px;
    margin-top: 10px;
    margin-bottom: 30px;
    text-align: center;
  }
}
.btn-box {
  display: flex;
  justify-content: center;
}
.el-button.el-button--primary {
  background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  border-radius: 8px;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  border: none;
  &:hover {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%) !important;
  }
}
.el-button.el-button--default {
  background: var(--input-bg, #f2f3f5);
  font-weight: 500;
  font-size: 14px;
  color: var(--text-primary, #0d1400);
  border: none;
}
.wechat-box {
  width: 180px;
  height: 220px;
  background: var(--card-bg, #ffffff);
  border-radius: 8px;
  text-align: center;
  padding: 20px 0;
  p {
    font-weight: 500;
    font-size: 14px;
    color: var(--text-primary, #0d1400);
    line-height: 20px;
  }
  .qr-code-box {
    width: 120px;
    height: 120px;
    margin: 10px auto;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    .logo-img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 30px;
      z-index: 1;
    }

    img {
      width: 100%;
      height: 100%;
    }
    .qr-scan-mask-cover {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #fff;
      z-index: 1000;
      .newLogin_scan-refresh {
        display: inline-block;
        font-style: normal;
        line-height: 0;
        text-align: center;
        text-transform: none;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        margin-bottom: 12px;
        font-size: 46px;
      }
      .loading-refresh {
        animation: identifier 1s linear infinite;
      }
      .refresh-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        content: "";
        background-color: #000;
        border-radius: 5px;
        opacity: 0.6;
        z-index: -1;
      }
    }
  }
}
@keyframes identifier {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
.bind-wechat-popover {
  padding: 0;
  border-radius: 8px;
}
</style>
